import { GlobalState } from '../../actions';

const actionTokenSelector = (state: GlobalState) => state.actionToken;

export const actionTokenCheckResponseSelector = (state: GlobalState) => actionTokenSelector(state).checkResponse;
export const actionTokenIsExecutedSelector = (state: GlobalState) => actionTokenSelector(state).isExecuted;
export const actionTokenCheckPasswordResultSelector = (state: GlobalState) =>
    actionTokenSelector(state).checkPasswordResult;
